import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  return (
    <>
      {/* <!-- Footer --> */}

      {/* <!-- Footer Start --> */}
      <footer className="footer mt-5 contact-bg text-light pt-5">
        <div className="container">
          <div className="row g-4">
            {/* Logo + About */}
            <div className="col-lg-4 col-md-6">
              <img
                className="img-fluid mb-3"
                src="/images/assets/rapidLabLogoWhite.png"
                alt="Rapid Lab Logo"
                style={{ maxWidth: "150px" }}
              />
              <h5>Rapid Lab & Diagnostics</h5>
              <p className="small">
                Your trusted partner for fast, accurate, and reliable medical
                testing services. We are committed to delivering quality
                diagnostics with care and professionalism.
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-lg-4 col-md-6">
              <h5 className="mb-3">Quick Links</h5>
              <ul className="list-unstyled d-flex flex-column gap-2">
                <li>
                  <HashLink
                    className="text-light text-decoration-none footer-link under-line"
                    to="/#rapid-home"
                  >
                    Home
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    className="text-light text-decoration-none footer-link under-line"
                    to="/about-us#rapid-about-us"
                  >
                    About Us
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    className="text-light text-decoration-none footer-link under-line"
                    to="/services#rapid-services"
                  >
                    Services
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    className="text-light text-decoration-none footer-link under-line"
                    to="/forms#t-form"
                  >
                    Book Appointment
                  </HashLink>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-4 col-md-12">
              <h5 className="mb-3">Contact Us</h5>

              <p className="d-flex align-items-center gap-2 small">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-telephone-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                    />
                  </svg>
                </span>{" "}
                +233 55 066 2915 <br /> +233 20 592 5509
              </p>

              <p className="d-flex align-items-center gap-2 small">
                ✉️ rapidlabdiagnostics@gmail.com <br />
                info@rapidlabdiagnostics.com
              </p>

              {/* Socials */}
              <div className="mt-3">
                <h6>Connect with Us</h6>
                <div className="d-flex gap-3 mt-2">
                  <Link
                    to="https://web.facebook.com/p/Rapid-Laboratory-Diagnostics-Centre-61565006593035/"
                    className="text-light"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="white"
                      className="bi bi-facebook"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                    </svg>
                  </Link>

                  <Link
                    to="https://instagram.com/rapidlabdiagnostics"
                    className="text-light"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="white"
                      className="bi bi-instagram"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                    </svg>
                  </Link>

                  <Link
                    to="https://wa.me/message/TITUAAVTBPDCD1"
                    className="text-light"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="white"
                      className="bi bi-whatsapp"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Accreditations */}
          <div className="text-center">
            <h5 className="text-light">Corporate and Insurance Partners</h5>
            <p className="text-light small">
              Licensed by the Ghana Health Service (GHS) | Registered with the
              Health Facilities Regulatory Agency (HeFRA) |Regulated by Ghana
              Health Service | NHIS Accredited Facility
            </p>
            <div className="container">
              <div
                className="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-3 justify-content-center align-items-stretch mx-auto"
                style={{ maxWidth: "900px" }}
              >
                <div className="col">
                  <div className="bg-white p-3 rounded shadow-sm border hover-card h-100 d-flex align-items-center justify-content-center">
                    <img
                      src="images/assets/NHIS-LOGO.png"
                      alt="Accreditation Logo"
                      className="img-fluid"
                    />
                  </div>
                </div>

                <div className="col">
                  <div className="bg-white p-3 rounded shadow-sm border hover-card h-100 d-flex align-items-center justify-content-center">
                    <img
                      src="images/assets/Hefra.png"
                      alt="Accreditation Logo"
                      className="img-fluid"
                    />
                  </div>
                </div>

                <div className="col">
                  <div className="bg-white p-3 rounded shadow-sm border hover-card h-100 d-flex align-items-center justify-content-center">
                    <img
                      src="images/assets/MOH.webp"
                      alt="Accreditation Logo"
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="bg-white p-3 rounded shadow-sm border hover-card h-100 d-flex align-items-center justify-content-center">
                    <img
                      src="images/assets/nuclear-logo.png"
                      alt="Accreditation Logo"
                      className="img-fluid w-100"
                    />
                  </div>
                </div>

                <div className="col">
                  <div className="bg-white p-3 rounded shadow-sm border hover-card h-100 d-flex align-items-center justify-content-center">
                    <img
                      src="images/assets/GHS.webp"
                      alt="Accreditation Logo"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <hr className="border-light opacity-25 my-4" />

          {/* Footer Bottom */}
          <div className="text-center small pb-3">
            &copy; {new Date().getFullYear()} Rapid Lab & Diagnostics. All
            rights reserved. | Developed by Michael Enchill | ✉️
            abeikuenchill20@gmail.com
          </div>
        </div>
      </footer>
      {/* <!-- Footer End --> */}
    </>
  );
};

export default Footer;
